import { fromJS } from 'immutable';

import {
  OP_GET_GLOBAL_DATA,
  OP_GET_GLOBAL_DATA_SUCCESS,
  OP_GET_GLOBAL_DATA_FAIL,
  OP_GET_SEGMENT_DATA,
  OP_GET_SEGMENT_DATA_SUCCESS,
  OP_GET_SEGMENT_DATA_FAIL,
  OP_GET_INSEGMENT_DATA,
  OP_GET_INSEGMENT_DATA_SUCCESS,
  OP_GET_INSEGMENT_DATA_FAIL,
  OP_GET_ANALYST_DATA,
  OP_GET_ANALYST_DATA_SUCCESS,
  OP_GET_ANALYST_DATA_FAIL,
  OP_GET_ANALYST_THROUGHPUT,
  OP_GET_ANALYST_THROUGHPUT_SUCCESS,
  OP_GET_ANALYST_THROUGHPUT_FAIL
} from '../../actions/tm/operation';

const initialState = fromJS({
  figures: {},
  tableMeta: {},
  tableData: {}
});

export default function operation(state = initialState, action) {
  switch (action.type) {
    case OP_GET_GLOBAL_DATA:
    case OP_GET_SEGMENT_DATA:
    case OP_GET_INSEGMENT_DATA:
    case OP_GET_ANALYST_DATA:
    case OP_GET_ANALYST_THROUGHPUT:
      return {
        ...state,
        payload: action.payload
      };
    case OP_GET_GLOBAL_DATA_SUCCESS:
      return {
        ...state,
        figures: action.payload
      };
    case OP_GET_SEGMENT_DATA_SUCCESS:
      return {
        ...state,
        segments: action.payload
      };
    case OP_GET_INSEGMENT_DATA_SUCCESS:
      return {
        ...state,
        inSegment: action.payload
      };
    case OP_GET_ANALYST_DATA_SUCCESS:
      return {
        ...state,
        analystList: action.payload
      };
    case OP_GET_ANALYST_THROUGHPUT_SUCCESS:
      return {
        ...state,
        analystThroughput: action.payload
      };
    case OP_GET_GLOBAL_DATA_FAIL:
    case OP_GET_SEGMENT_DATA_FAIL:
    case OP_GET_INSEGMENT_DATA_FAIL:
    case OP_GET_ANALYST_DATA_FAIL:
    case OP_GET_ANALYST_THROUGHPUT_FAIL:
    default:
      return {
        ...state
      };
  }
}
